<template id="bannerTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>

    <!-- Snackbar -->
    <div id="snackbar" class="snackbar alert">{{serverMessage}}</div>

    <div class="main-div">
      <div class="p-2 header">
            <h3 class="text-left"> Users Carts</h3>
          </div>
      <!-- Loading -->
      <div class="spinner-wrapper" v-bind:class="isLoading ? 'show' : 'hide'">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <p class="alert alert-danger text-left" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
      </p>

        <div role="tablist">
          <b-card-header header-tag="header" class="p-1 pt-2 pb-2" role="tab">
              <b-button block  variant="info" class="d-flex cartTap"><span>Cart #</span> <span>User Name</span><span>User Mobile</span><span>User Email</span><span>User Country</span></b-button>
            </b-card-header>
          <b-card no-body class="col-12 mb-1 p-0" v-for="(cart, index) in this.carts" :key="index+1">
            
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-' + (index+1)" variant="info" class="d-flex cartTap"><span>Cart #{{index+1}} </span> <span v-if="cart.User">{{cart.User.name}}</span><span v-if="cart.User">{{cart.User.mobile}}</span><span v-if="cart.User">{{cart.User.email}}</span><span v-if="cart.User">{{cart.User.Place.Country.name}}</span></b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + (index+1)" accordion="my-accordion" role="tabpanel">
              <b-card-body class="row text-left">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Product Image</th>
                      <th scope="col">Product Price</th>
                      <th scope="col">Product Slug</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, index) in cart.CartProductRelationships" :key="index+1">
                      <th scope="row">#{{index+1}}</th>
                      <td>{{product.Product.title}}</td>
                      <td><img :src="product.Product.image" width="100px"/></td>
                      <td>{{product.Product.price}}</td>
                      <td>{{product.Product.slug}}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

.toolbar {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  right: 0;
  padding: 10px 50px;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 99;
}

h1 {
  margin-bottom: 0;
}

.card {
  transition: all 150ms ease-in-out;

  &:hover {
    background: #fafafa;
  }
}

.img-preview {
  max-height: 500px;
  text-align: center;

  img {
    width: auto;
    max-width: 100%;
    height: 100%;
  }
}

.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}

.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  margin-top: 50px;
  padding: 50px;
  width: 80%;
}

.spinner-wrapper {
  display: none;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 100%;
  top: 0;
  right: 0;
  background: rgba(230, 230, 230, 0.61);
  z-index: 99;
}
.spinner-wrapper.show {
  display: flex;
}
.spinner-wrapper.hide {
  display: none;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
}

.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

/* The snackbar - position it at the bottom and in the middle of the screen */
.snackbar {
  position: fixed;
  bottom: -100px;
  left: 40%;
  z-index: 1;
  transition: all 300ms ease-in-out;
}

.snackbar.show {
  bottom: 30px;
  opacity: 1;
}
.cartTap{
  display: flex;
  span{
    
    width: 20%;
    border-right: 1px solid #fff;
    &:first-child{
      text-align: left;
      width: 10%;
    }
    &:last-child{
      border-right: none;
    }
    &:nth-child(2){
      width: 25%;
    }
    &:nth-child(4){
      width: 25%;
    }
  }
}
  .header {
    padding-top: 16px !important;
    background: black;
    color: #b78b1e;
  }
</style>

<script>
import axios from "axios";
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "banner",
  data() {
    return {
      carts: [],
      errors: [], // Form's errors
      serverMessage: "",
      isLoading: false
    };
  },
  watch: {},
  mounted() {
    this.fetchCarts();
  },
  methods: {
    fetchCarts() {
      // Show Loader
      this.isLoading = true;

      // Get Slides Data
      return axios
        .get(`${herokuUrl}/dashboard/users_carts`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.carts = res.data.carts;
          // Stop the loader
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 401) {
            logOut();
          } else {
            this.isLoading = false;
            alert("Banner fetching failed, " + err.response.data.message);
            // console.log(err);
          }
        });
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
